import { useState } from 'react';
import { enableMfa } from '@hotjar/webapp/domains/mfa/api';

export const useMfaCodeVerification = (
  userId: number,
  onEnabled: () => void,
): {
  handleChange: (newOtp: string) => void;
  handleInput: (valuesArr: number[]) => void;
  submit: () => void;
  error: string | null;
  isLoading: boolean;
} => {
  const [error, setError] = useState<string | null>(null);
  const [otp, setOtp] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleInput = (valuesArr: number[]) => {
    const newCode = valuesArr.join('');
    const codeHasChanged = newCode !== otp;
    setOtp(valuesArr.join(''));

    if (newCode && codeHasChanged) {
      setError(null);
    }
  };

  const handleEnableMfa = (currentOtp: string) => {
    setIsLoading(true);

    enableMfa({ userId, otp: currentOtp })
      .then(() => {
        onEnabled();
      })
      .catch((err) => {
        setError(err.response.data.errors.otp[0]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleChange = (newOtp: string) => {
    setOtp(newOtp);
    handleEnableMfa(newOtp);
  };

  const submit = () => {
    handleEnableMfa(otp);
  };

  return { handleChange, handleInput, submit, error, isLoading };
};
